export default "/_next/static/fonts/Honey-ExtraboldBanner-e504e7a9f2882288f33c74b2dec02dd2.woff";